export default "__VITE_ASSET__337cc548__$_?used__"